<script lang="ts">
	import type { Post } from "@core/schema/Post.js";
	import { toDateMonthYearFormat } from "@core/utils/toDateMonthYearFormat.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { tenant } = getGlobalTemplateProps();
	const { post }: { post: Pick<Post, "publishedAt"> } = $props();
</script>

{#if post.publishedAt !== undefined}
	<time datetime={post.publishedAt} class="text-sm/normal sm:text-base text-fcrgray">
		{toDateMonthYearFormat(post.publishedAt, tenant.locale)}
	</time>
{/if}
